<template>
	<div>
        <div v-if="showHeader" class="mb-3 flex items-center justify-between border-b border-gray-200 pb-2">
        	<div class="flex items-center">
				<h1 class="module-header">Building Information</h1>
				<span class="ml-4 inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-base font-medium text-green-700 ring-1 ring-inset ring-green-600/20">{{ building.type.type }}</span>
			</div>
			<button v-if="canEditBuilding()" @click="launchEditBuilding" type="button" class="btn btn-small btn-indigo flex items-center">
                <inline-svg name="edit" classes="w-4 h-4 text-white fill-current"></inline-svg>
                <span class="ml-2">Edit Building</span>
			</button>
        </div>

	    <div v-if="buildingFields.length" class="w-full flex flex-col printing:flex-col md:flex-row">
			<div class="w-full printing:w-full md:w-4/5">
				<div class="w-full table">
					<div class="table-row odd:bg-white even:bg-gray-50" v-for="rowIdx in Math.ceil(buildingFields.length / 2)" :key="rowIdx">
						<div class="table-cell p-2" v-for="(item, itemIndex) in buildingFields.slice(2 * (rowIdx - 1), 2 * rowIdx)" :key="itemIndex">
							<span class="min-w-[10rem] text-sm font-bold">{{ item.label }}:</span>
							<span v-if="building[item.field] == null">-</span>
							<span v-else-if="item.type == 'integer' || item.type == 'double'">
								{{ building[item.field] | number(item.type == 'double' ? 1 : 0) }}
							</span>
							<span v-else-if="item.type == 'currency'" data-precision="2" :data-originalvalue="item[item.field]" class="is-currency">
								{{ formatCurrency(building[item.field], 2) }}
							</span>
							<span v-else-if="item.type == 'percentage'">
								{{ building[item.field] | number }}%
							</span>
							<span v-else>{{ building[item.field] || '-' }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="md:mt-0 md:ml-3 printing:ml-0 px-2 py-8 w-full printing:w-full md:w-1/5">
				<div class="grid grid-cols-4 printing:grid-cols-4 md:grid-cols-1 gap-x-4 printing:gap-y-5">
					<div v-for="(row, rowIndex) in buildingToggleFields" :key="rowIndex" class="mb-6 printing:mb-0 flex items-center leading-5">
						<div>
							<inline-svg v-if="building[row.field]" name="check" classes="w-4 lg:w-7 fill-current text-green-500"></inline-svg>
							<inline-svg v-else name="x" classes="w-4 lg:w-7 fill-current text-red-500"></inline-svg>
						</div>
						<label :for="row.field" class="ml-2 mb-0 pt-0 block text-xs md:text-lg font-medium text-gray-700">{{ row.label }}</label>
					</div>
				</div>
			</div>
	    </div>
	</div>
</template>

<script>
    export default {
    	props: {
    		buildingData: {
    			type: Object,
    			required: true
    		},

			showHeader: {
				type: Boolean,
				default: true
			}
    	},

    	data() {
    		return {
    			building: this.buildingData,

    			buildingTypes: {}
    		}
    	},

        created() {
            this.initBuildingTypes();
        },

		computed: {
			buildingFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;

					return _.remove(fields, (field) => {
						return field.type != 'boolean'
					});
				}

				return [];
			},

			buildingToggleFields() {
				if (this.buildingTypes.length && this.building.type_id != null) {
					let fields = _.find(this.buildingTypes, ['id', this.building.type_id]).fields;

					return _.remove(fields, (field) => {
						return field.type == 'boolean'
					});
				}

				return [];
			}
		},

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types').then((response) => {
                    this.buildingTypes = response.data.types;
                }).catch((error) => {
                    console.log(error);
                });
            },

            launchEditBuilding() {
            	window.location = '/admin/buildings/' + this.building.id + '/edit';
            },

			canEditBuilding() {
				return this.$gate.can('edit', 'site', this.site);
			}
        }
    }
</script>
